const routes = [
  {
    path: "/components",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/pages/Home/Home.vue"),
    meta: {
      title: "Home - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
